import { FileX } from 'lucide-react';

interface CloseDocumentConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function CloseDocumentConfirmModal({
  isOpen,
  onClose,
  onConfirm
}: CloseDocumentConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-navy-800 border border-navy-700 rounded-lg p-4 w-[340px]">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-2 bg-red-500/15 rounded-lg">
            <FileX className="w-5 h-5 text-red-400" />
          </div>
          <div className="text-sm text-gray-100 font-medium">Fechar Documento?</div>
        </div>
        <div className="text-xs text-gray-400 mb-4">
          O documento atual será fechado no CorelDRAW. Certifique-se de que todas as alterações foram salvas antes de continuar.
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs rounded border border-navy-600 text-gray-300 hover:bg-navy-700 transition-colors"
          >Cancelar</button>
          <button
            onClick={onConfirm}
            className="px-3 py-1.5 text-xs rounded bg-red-600 hover:bg-red-500 text-white transition-colors"
          >Fechar Documento</button>
        </div>
      </div>
    </div>
  );
}
